/**
 * Promo code configuration constants
 * LinkedIn promotional codes with date ranges for automatic rotation
 */

/**
 * LinkedIn promo code configuration
 * Each entry contains:
 * - code: The promo code string
 * - startDate: When the code becomes active on Twine (UTC)
 * - endDate: When the code should be removed from Twine (UTC)
 * - stripeExpiry: When the code expires on Stripe (automated, 6 days after endDate)
 * - period: Human-readable period description
 */
export const LINKEDIN_PROMO_CODES = [
  {
    code: 'WORK100',
    startDate: null, // Already active
    endDate: new Date('2025-12-18T00:00:00Z'), // Ends when PROLINK100 starts
    period: '2025',
  },
  {
    code: 'PROLINK100',
    startDate: new Date('2025-12-18T00:00:00Z'), // ASAP (Dec 18, 2025)
    endDate: new Date('2026-03-01T00:00:00Z'),
    stripeExpiry: new Date('2026-03-07T00:00:00Z'),
    period: 'Jan-Feb 26',
  },
  {
    code: 'GROWTH100',
    startDate: new Date('2026-03-01T00:00:00Z'),
    endDate: new Date('2026-05-01T00:00:00Z'),
    stripeExpiry: new Date('2026-05-07T00:00:00Z'),
    period: 'Mar-Apr 26',
  },
  {
    code: 'SKILL100UP',
    startDate: new Date('2026-05-01T00:00:00Z'),
    endDate: new Date('2026-07-01T00:00:00Z'),
    stripeExpiry: new Date('2026-07-07T00:00:00Z'),
    period: 'May-Jun 26',
  },
  {
    code: 'SUCCESS100',
    startDate: new Date('2026-07-01T00:00:00Z'),
    endDate: new Date('2026-09-01T00:00:00Z'),
    stripeExpiry: new Date('2026-09-07T00:00:00Z'),
    period: 'July-Aug 26',
  },
  {
    code: 'INSIGHT100',
    startDate: new Date('2026-09-01T00:00:00Z'),
    endDate: new Date('2026-11-01T00:00:00Z'),
    stripeExpiry: new Date('2026-11-07T00:00:00Z'),
    period: 'Sep-Oct 26',
  },
  {
    code: 'LEADGEN100',
    startDate: new Date('2026-11-01T00:00:00Z'),
    endDate: new Date('2027-01-01T00:00:00Z'),
    stripeExpiry: new Date('2027-01-07T00:00:00Z'),
    period: 'Nov-Dec 26',
  },
];
